import { lazy } from 'react';

const TechAdmin = lazy(() => import('./TechAdmin'));

export default TechAdmin;
